import { LayoutPropTypes } from '../components/layout/LayoutPropTypes';

export const ROUTE_CONSTANTS: Record<string, LayoutPropTypes> = {
   home: {
      path: '/reverification',
      pageName: 'SKYC_LANDING_PAGE',
      showHeader: true,
      showFooter: false,
   },
   thankyou: {
      path: '/reverification/thank-you',
      pageName: 'SKYC_THANK_YOU',
      showHeader: true,
      showFooter: false,
   },
   newSkycUserDetails: {
      path: '/details',
      pageName: 'NEW_ACQ_POSTPAID_SKYC_LANDING_PAGE',
      showHeader: true,
      showFooter: false,
   },
   newSkyc: {
      path: '/verification',
      pageName: 'NEW_ACQ_POSTPAID_SKYC',
      showHeader: true,
      showFooter: false,
   },
   orderSummary: {
      path: '/order-summary',
      pageName: 'NEW_ACQ_POSTPAID_SKYC_ORDER_SUMMARY_PAGE',
      showHeader: true,
      showFooter: false,
   },
   newSkycThankYou: {
      path: '/thank-you',
      pageName: 'NEW_ACQ_POSTPAID_SKYC_THANK_YOU',
      showHeader: true,
      showFooter: false,
   },
   prereadPage: {
      path: '/',
      pageName: 'NEW_ACQ_SKYC_PREREAD_PAGE',
      showHeader: true,
      showFooter: false,
   },
};

export const PAGESPACE_PAGES = Array.from(
   new Set(Object.values(ROUTE_CONSTANTS).map((route) => route.pageName))
);

export const BASE_HREF = '/kyc';
export const IS_PRODUCTION = window?.location?.origin?.includes('www.airtel.in');
export const IS_LOCAL = process.env.NODE_ENV === 'development';
